// Branch/location/manager are now maintained in the Branch, Location, and
// ReportingManager master-data tables (Master Records in the admin UI) —
// fetch via GET_BRANCHES()/GET_LOCATIONS()/GET_MANAGERS() in api/index.js
// instead of hardcoding a copy here.

export const TEAM_HEADS = [
    "Vinod",
    "Sathish",
    "HO",
];
